import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data, options }) => {
  const hasData =
    Array.isArray(data?.labels) &&
    data.labels.length > 0 &&
    Array.isArray(data?.datasets) &&
    data.datasets.length > 0;
  return (
    <div>
      <h3>Información de pagos por mes</h3>
      {hasData ? (
        <Bar
          data={data}
          options={options}
        />
      ) : (
        <h3 className='error-msj'>No hay datos para mostrar</h3>
      )}
    </div>
  );
};

export default BarChart;
